//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TeacherPhotoStyled',
  props: {
    photoUrl: {
      type: String,
      required: true,
      default: '',
    },
    noAvatar: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
}
